<template>
    <div class="Progress">
        <v-container fluid>
            <v-card>
                <v-card-title primary-title>
                  <h2>Reporte por Procesos y Organizacion jerarquica</h2>
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm6 md4>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Fecha"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap align-center justify-space-around>
                        <v-flex xs12 sm2 d-flex>
                            <v-select
                                :items="empresas"
                                item-text="label"
                                item-value="id"
                                v-model="empresa"
                                label="Empresa"
                                :clearable="true"
                                >

                                </v-select>
                        </v-flex>
                         <v-flex xs12 sm2 d-flex>
                            <v-select
                                item-text="label"
                                item-value="id"
                                :items="departamentos"
                                v-model="departamento"
                                label="Departamento"
                                :clearable="true"
                                ></v-select>
                        </v-flex>
                        <v-flex xs12 sm2 d-flex>
                            <v-select
                                :items="localidades2"
                                item-text="label"
                                item-value="id"
                                v-model="localidad"
                                label="Localidad"
                                :clearable="true"
                                ></v-select>
                        </v-flex>

                    </v-layout>

                </v-card-text>
                    <v-layout row wrap align-center justify-center>
                        <v-flex xs1>
                            <v-btn color="success" v-on:click="getReporte">Buscar</v-btn>
                        </v-flex>
                    </v-layout>
                <v-card-actions>

                </v-card-actions>

            </v-card>

            <v-card v-if="resultados">
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex  xs4>
                    <v-card>
                      <v-card-title primary-title>
                        <h2>Numero de participantes</h2>
                        <v-spacer></v-spacer>
                        <v-icon x-large color="green darken-1">people</v-icon>
                      </v-card-title>
                      <v-card-text>
                        <br>
                        <h2>{{nparticipantes}}</h2>
                      </v-card-text>
                    </v-card>

                  </v-flex>
                  <v-flex  xs4>
                    <v-card>
                      <v-card-title primary-title>
                        <h2>Participantes con algún síntoma</h2>
                        <v-spacer></v-spacer>
                        <v-icon x-large color="red darken-2">person_remove</v-icon>
                        (Tos, Fatiga, Degustar, Se ha saltado comidas)
                      </v-card-title>
                      <v-card-text>

                        <h2>{{ninfectados}}</h2>
                      </v-card-text>
                    </v-card>

                  </v-flex>
                  <v-flex  xs4>
                    <v-card>
                      <v-card-title primary-title>
                        <h2>Porcentaje de contagio</h2>
                        <v-spacer></v-spacer>
                        <v-icon x-large color="yellow darken-3">warning</v-icon>
                      </v-card-title>
                      <v-card-text>
                        <br>
                        <h2  class="red--text text--darken-4">{{porcentaje}}% </h2>
                      </v-card-text>
                    </v-card>

                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
        </v-container>
    </div>
</template>
<script>

export default {

  name: 'Reporte Medico',

  data () {
    return {
      items: ['Empresa', 'Gerencia'],
      empresa: null,
      chipEmpresa: true,
      localidad: null,
      departamento: null,
      percentCovid: null,
      resultados: null,

      backConf: {
        path: '/projects/covid/categorias/',
        pathFiltros: '/projects/covid/filtros/',
        page: 1
      },

      headers: [],
      dataVals: null,

      date: new Date().toISOString().substr(0, 10),
      menu: false,

      modal: false,
      menu2: false,
      empresas: [],
      departamentos: [],
      localidades: [], // localidades de Bogota
      localidadesAtl: [], // localidades de Atlantico
      nparticipantes: null,
      ninfectados: null,
      porcentaje: null

    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.initialize()
  },

  computed: {
    'localidades2': function () {
      let l = []
      if (this.departamento === '11') {
        l = this.localidades
      } else if (this.departamento === '08') {
        l = this.localidadesAtl
      } else {
        return l
      }
      return l
    }
  },

  methods: {
    initialize () {
      this.getFiltros()
      // this.getReporte()
    },

    getFiltros () {
      let request = {
        method: 'get',
        url: this.backConf.pathFiltros,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.empresas = resp.data['empresas']
          t.departamentos = resp.data['departamentos']
          t.localidades = resp.data['localidadesBogota']
          t.localidadesAtl = resp.data['localidadesAtlantico']
        })
        .catch(err => console.error(err))
    },

    getReporte () {
      this.nparticipantes = null
      this.ninfectados = null
      this.porcentaje = null
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          fecha: this.date
        }
      }

      if (this.departamento != null) {
        request.params['departamento'] = this.departamento
        if (this.localidad != null && this.departamento === '11') {
          request.params['localidadBog'] = this.localidad
        } else if (this.localidad != null && this.departamento === '08') {
          request.params['localidadAtl'] = this.localidad
        } else {

        }
      }

      if (this.empresa != null) {
        request.params['empresa'] = this.empresa
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.resultados = true

          t.nparticipantes = resp.data['n']
          t.ninfectados = resp.data['infectados']
          t.porcentaje = resp.data['porcentaje']
          t.updateTable()
          // t.chartSeries = resp.data
          // t.chartSeries.pop()
          // t.chartOptions.yaxis.pop()
          // t.loading = false
          // t.chartKey += 1
        })
        .catch(err => console.error(err))
    },

    /**
         * Función que actualiza los datos de headers de la tabla
        */
    updateTable () {
      let t = this
      console.log('datavals Objects:')
      console.log(Object.keys(t.dataVals[0]))

      let keys = Object.keys(this.dataVals[0])
      // let keys = Object.keys(this.dataVals)
      // keys.pop()

      let head = []
      let labs = []

      keys.forEach(function (k, index) {
        head.push(
          { text: k, value: k, str: ' ' }
        )
        labs[k] = k
      })

      // // labs.total = 'Respuestas'
      // // labs.percentage = 'Porcentaje'

      this.headers = head
      console.log('headers::::::::')
      console.log(this.headers)

      // // this.labels = labs

      // // this.fields = Object.keys(this.dataVals[0])
    },

    enviar () {
      // console.log("cosas");
      console.log(this.proceso + this.gerencia + this.percentCovid + this.localidad)
      console.log(this.date)
    }
  }

}
</script>
